export const isOfficialSite = () => {
    const url = document.URL;
    if (url.indexOf("www.heritageunderwear.com") !== -1) {
        return true;
    }
    return false;
}